/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    /*!************************!*\
      !*** ./src/js/main.js ***!
      \************************/
    function isElementXPxInViewport(el) {
        if(!el) return false;
        let x = el.getBoundingClientRect().left;
        let y = el.getBoundingClientRect().top;
        let ww = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        let hw = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        let w = el.clientWidth;
        let h = el.clientHeight;
        return (
            (y < hw &&
                y + h > 0) &&
            (x < ww &&
                x + w > 0)
        );
    }
    
    let scrollSection = [];
    let scrollInitted = false;
    
    $.fn.scrollAppearance = function(timeout = false, decreaseTimeout = false, afterFunction = false){
        let container = $(this)
        let pxContainer = 10;
    
        let methods = {
            init: function () {
                $(window).on('scroll', function () {
                    if(scrollSection.length)
                        methods.checkBlocks()
                })
                $(document).on('check-appearance', methods.checkBlocks)
            },
            checkBlocks: function (){
                scrollSection.forEach(function (item, index) {
                    let thisContainerVisible = isElementXPxInViewport(item.section[0])
    
                    if(!thisContainerVisible || item.section.hasClass('scroll-appearance-done')) return ;
    
    
                    let time = false;
                    let thisBlock = item.blocks.eq(0)
                    let blockInView = isElementXPxInViewport(thisBlock[0])
    
                    if(!blockInView){
                        let found = false;
                        item.blocks.each(function () {
                            if(isElementXPxInViewport(this) && !found){
                                thisBlock = $(this)
                                blockInView = true;
                                found = true;
                            }
                        })
                    }
    
                    if(!blockInView || thisBlock.hasClass('scroll-appearance-shown') || thisBlock.hasClass('scroll-appearance-animating')) return ;
    
                    thisBlock.addClass('scroll-appearance-animating')
    
                    clearTimeout(time)
    
                    time = setTimeout(function () {
                        clearTimeout(time)
    
                        thisBlock.addClass('scroll-appearance-shown')
                        thisBlock.removeClass('scroll-appearance-animating')
    
                        scrollSection[index].blocks = item.section.find('.scroll-appearance:not(.scroll-appearance-shown)')
    
                        let nextBlock = scrollSection[index].blocks.eq(0)
    
                        if(!scrollSection[index].blocks.length)
                            item.section.addClass('scroll-appearance-done')
    
                        if(item.afterFunction){
                            item.afterFunction(thisBlock)
                        }
    
                        if(item.decreaseTimeout)
                            item.timeout -= decreaseTimeout
    
                        let nextBlockInView = isElementXPxInViewport(nextBlock[0])
    
                        if(nextBlock.length && nextBlockInView)
                            methods.checkBlocks()
    
                    }, item.timeout ? item.timeout : 0)
                })
            },
            addSection: function () {
                let blocks = container.find('.scroll-appearance:not(.scroll-appearance-shown)')
    
                scrollSection.push({
                    section: container,
                    blocks: blocks,
                    timeout: timeout,
                    decreaseTimeout: decreaseTimeout,
                    afterFunction: afterFunction,
                    sumTimeout: 0
                })
                methods.checkBlocks()
            },
            showBlocks: function (section) {
                section.blocks.each(function () {
                    let thisBlock = $(this)
    
                    thisBlock.addClass('scroll-appearance-shown')
                    if(section.afterFunction){
                        section.afterFunction(thisBlock)
                    }
                })
    
            }
        }
        if(!scrollInitted) {
            methods.init()
            scrollInitted = true;
        }
        methods.addSection()
    
        return methods;
    }


    function fadeIn(el, timeout, display) {
      let afterFunc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      el.style.opacity = 0;
      el.style.display = display || 'block';
      el.style.transition = `opacity ${timeout}ms`;
      setTimeout(() => {
        el.style.opacity = 1;
        if (afterFunc) {
          setTimeout(function () {
            afterFunc();
          }, timeout);
        }
      }, 10);
    };
    function fadeOut(el, timeout) {
      let afterFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      el.style.opacity = 1;
      el.style.transition = `opacity ${timeout}ms`;
      el.style.opacity = 0;
      setTimeout(() => {
        el.style.display = 'none';
        if (afterFunc) {
          afterFunc();
        }
      }, timeout);
    };
    
    /* SLIDE UP */
    let slideUp = function (target) {
      let duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.boxSizing = 'border-box';
      target.style.height = target.offsetHeight + 'px';
      target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      window.setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
      }, duration);
    };
    
    /* SLIDE DOWN */
    let slideDown = function (target) {
      let duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
      target.style.removeProperty('display');
      let display = window.getComputedStyle(target).display;
      if (display === 'none') display = 'block';
      target.style.display = display;
      let height = target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      target.offsetHeight;
      target.style.boxSizing = 'border-box';
      target.style.transitionProperty = "height, margin, padding";
      target.style.transitionDuration = duration + 'ms';
      target.style.height = height + 'px';
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);
    };
    
    /* TOOGLE */
    var slideToggle = function (target) {
      let duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
      if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration);
      } else {
        return slideUp(target, duration);
      }
    };
    function dropdown(options) {
      let opts = {
          closeOnClick: true,
          timing: false,
          closeBtnClass: false,
          globalContainer: '',
          effect: 'fade'
      };
      let timing = 300;
      $.extend(opts, options);
      function open(e) {
          e.preventDefault();
          let container = $(this).closest('.' + opts.containerClass);
          let thisDropdown = container.find(opts.dropdownSelector);
          if (e.type === 'focusin') container.addClass('focusin');
          if ((container.hasClass('is-open') || container.hasClass('disabled')) && !container.hasClass('focusin')) {
          close();
          return;
          }
          if (e.type !== 'focusin') container.removeClass('focusin');
          close(container);
          container.addClass('is-open').css('z-index', '4');
          if (opts.effect === 'fade') {
          thisDropdown.fadeIn(timing);
          } else {
          thisDropdown.slideDown(timing);
          }
      }
      function close() {
          let dontClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          let dropdownsToClose = $('.' + opts.containerClass);
          if (dontClose) dropdownsToClose = dropdownsToClose.not(dontClose);
          dropdownsToClose.find('li').removeClass('hover');
          dropdownsToClose.removeClass('is-open');
          if (opts.effect === 'fade') {
          dropdownsToClose.find(opts.dropdownSelector).fadeOut(timing);
          } else {
          dropdownsToClose.find(opts.dropdownSelector).slideUp(timing);
          }
          setTimeout(function () {
          dropdownsToClose.removeAttr('style');
          }, timing);
      }
      $(document).on('click', function (e) {
          let thisEl = $(e.target);
          if (opts.closeBtnClass ? thisEl.hasClass(opts.closeBtnClass) : false) close();
          if (!thisEl.hasClass(opts.containerClass) && !thisEl.closest('.' + opts.containerClass).length) close();
      });
      $(document).on('click', opts.globalContainer + ' .' + opts.containerClass + ' ' + opts.btnSelector, open);
      $(document).on('focusin', opts.globalContainer + ' .' + opts.containerClass + ' ' + opts.btnSelector, open);
      $(document).on('focusout', opts.globalContainer + ' .' + opts.containerClass + ' ' + opts.btnSelector, function () {
          $(this).closest('.' + opts.containerClass).removeClass('focusin');
          close($(this).closest('.' + opts.containerClass));
      });
      $(document).on('close-dropdown', close);
      if (options.timing !== false) timing = options.timing;
      if (options.containerClass === 'select') timing = 0;
      if (opts.closeOnClick) {
          $(document).on('click', opts.globalContainer + ' .' + opts.containerClass + ' ' + opts.dropdownSelector, function () {
          if (!$(this).closest('.' + opts.containerClass).hasClass('has-checkbox')) close();
          });
      }
    }
    function setCookie(cookieName, cookieValue) {
      document.cookie = cookieName + "=" + cookieValue + "; path=/";
    }
    if (typeof csrftoken === 'undefined' && typeof getCookie === 'function') {
      const csrftoken = getCookie('csrftoken');
    }

    function anchors() {
      $('a[href*="#"]').on('click', function () {
        let href = $(this).attr('href');
        let block = $('#' + href.split('#').pop());
        if (block.length) {
          $('html,body').animate({
            scrollTop: block.offset().top + 50
          }, {
            duration: 1E3
          });
        }
      });
    }
    
    const only_num = /^[0-9.]+$/;
    const tel_reg = /^[0-9+]+$/;
    const only_num_replace = /[^0-9.]/g;
    const tel_reg_replace = /[^0-9+]/g;
    //const email_reg = /^(([^<>()\[\]\\.,;:\s@"]{2,62}(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z-аА-яЯ\-0-9]+\.)+[a-zA-Z-аА-яЯ]{2,62}))$/;
    const email_reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const validationRules = {
      'email': {
        'rules': {
          regex: email_reg
        }
      },
      'numeric': {
        'rules': {
          regex: only_num
        }
      },
      'phone': {
        'rules': {
          regexReplace: tel_reg_replace
        }
      },
      'password': {
        'rules': {
          password: true
        }
      },
      'password_repeat': {
        'rules': {
          password_repeat: true
        }
      }
    };
    function selectAll(selector) {
      let container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return Array.from(!container ? document.querySelectorAll(selector) : container.querySelectorAll(selector));
    }
    function printf(string, vars = []) {
      vars.forEach(function (thisVar, index) {
          string = string.replaceAll('&' + (index + 1), thisVar)
      })
      return string;
    }
    function validate(form, newOpts = {}) {
      let defaultOpts = {
          methodsOnInput: ['regexReplace', 'maxlength'],
          submitFunction: null,
          highlightFunction: null,
          unhighlightFunction: null,
          checkOnInput: false,
          checkOnInputAfterSubmit: true,
          checkOnFocusOut: true,
          errorClass: 'is-error',
          dontValidateInputs: 'input:not([type="hidden"])[name], .output_value, select, textarea',
          inputContainerSelector: '.input',
          validationRules: typeof validationRules !== 'undefined' ? validationRules : {},
          validationErrors: typeof validationErrors !== 'undefined' ? validationErrors : {},
          methods: {
              "regex": function (value, element, regexp) {
                  return value == '' || new RegExp(regexp).test(value);
              },
              "required": function (value, input) {
                  if(input.getAttribute('type') === 'checkbox' || input.getAttribute('type') === 'radio'){
                      let elseInputs = Array.from(form.querySelectorAll(`[name="${input.getAttribute('name')}"]`))
                      let hasChecked = !!elseInputs.find(item => item.checked)
  
                      if(hasChecked){
                          elseInputs.forEach(function (elseInput) {
                              elseInput.removeError()
                          })
                      }
  
                      return hasChecked
                  } else {
                      return !!value.trim()
                  }
              },
              "regexReplace": function (value, element, regexp) {
                  element.value = element.value.replace(new RegExp(regexp), "");
                  return true;
              },
              "password_repeat": function (value, element, regexp) {
                  let password = element.closest('form').querySelector('[data-validation="password"]');
                  return !element.hasAttribute('required') && !value || value === password.value;
              },
              "tel_mask": function (value, element, regexp) {
                  if (typeof element['checkValidCallback'] !== 'undefined') {
                      element.checkValidCallback();
                  }
                  return typeof element['telMask'] !== 'undefined' ? element['telMask'].isValidNumber() || value === '' : true;
              },
              "minlength": function (value, element, passedValue) {
                  let min = passedValue || +element.getAttribute("minlength");
  
                  if (!min || !value) return true;
                  return value.length >= min;
              },
              "maxlength": function (value, element, regexp) {
                  let max = +element.getAttribute("maxlength");
                  if (!max) return true;
                  if (element.value.length > max) {
                      element.value = element.value.substr(0, max);
                  }
                  return true;
              }
          }
      };
      let opts = {
          ...defaultOpts,
          ...newOpts
      };
      if(typeof validationMethods === 'object') {
          opts["methods"] = {
              ...opts["methods"],
              ...validationMethods
          }
      }
      if (typeof form === 'string') form = document.querySelector(form);
  
      function getMethodError(input, methodName, defaultText, variable = []) {
          let dataValidation = input.getAttribute('data-validation');
          let errorMessage = printf(defaultText, variable)
  
          if(opts.validationErrors[methodName]){
              errorMessage = printf(opts.validationErrors[methodName], variable)
          }
          if(opts.validationErrors[dataValidation] && opts.validationErrors[dataValidation][methodName]){
              errorMessage = printf(opts.validationErrors[dataValidation][methodName], variable)
          }
  
          return errorMessage;
      }
  
      function formSubmitListener(e) {
          e.preventDefault();
          _this.validate();
          _this.formSubmitted = true;
      }
      function inputInputListener(e) {
          this['had_input'] = true;
          if (opts.methodsOnInput.length) {
              _this.valid(this, opts.methodsOnInput);
              return;
          }
          if (opts.checkOnFocusOut && input['had_focusout']) {
              _this.valid(this);
              return;
          }
          if (opts.checkOnInput) {
              _this.valid(this);
              return;
          }
          if (opts.checkOnInputAfterSubmit && _this.formSubmitted) {
              _this.valid(this);
          }
  
          let inputsSameName = Array.from(form.querySelectorAll(`[name="${this.getAttribute('name')}"]`))
  
          if(inputsSameName.length > 1){
              let isTypesSame = !inputsSameName.find(item => item.getAttribute('type') !== inputsSameName[0].getAttribute('type'))
              let hasRequired = inputsSameName.find(item => typeof item.getAttribute('required') !== 'undefined')
  
              if(!isTypesSame && hasRequired) {
                  if(this.getAttribute('type') !== 'checkbox' && this.getAttribute('type') !== 'radio'){
                      let diffInputs = inputsSameName.filter(item => item.getAttribute('type') !== this.getAttribute('type'))
  
                      if(diffInputs.length){
                          if(this.value.trim()){
                              diffInputs.forEach(item => item.isValid())
                          }
                      }
                  }
              }
          }
      }
      function inputFocusListener(e) {
          let inputsSameName = Array.from(form.querySelectorAll(`[name="${this.getAttribute('name')}"]`))
  
          if(inputsSameName.length > 1){
              let isTypesSame = !inputsSameName.find(item => item.getAttribute('type') !== inputsSameName[0].getAttribute('type'))
              let hasRequired = inputsSameName.find(item => typeof item.getAttribute('required') !== 'undefined')
  
              if(!isTypesSame && hasRequired) {
                  if(this.getAttribute('type') !== 'checkbox' && this.getAttribute('type') !== 'radio'){
                      let diffInputs = inputsSameName.filter(item => item.getAttribute('type') !== this.getAttribute('type'))
  
                      if(diffInputs.length){
                          diffInputs.forEach(item => item.removeRequired())
                          diffInputs.forEach(item => item.checked = false)
                          diffInputs.forEach(item => item.isValid())
                      }
                      this.setRequired()
                  }
              }
          }
      }
      function inputFocusoutListener(e) {
          if (!opts.checkOnInput && opts.checkOnFocusOut) {
              this['had_focusout'] = true;
              if (!this['had_focusout'] || !this['had_input']) return;
              _this.valid(this);
          }
      }
      function inputChangeListener(e) {
          if (this.getAttribute('type') === 'checkbox' || this.getAttribute('type') === 'radio' ) {
              this.isValid()
          }
  
  
          let inputsSameName = Array.from(form.querySelectorAll(`[name="${this.getAttribute('name')}"]`))
  
          if(inputsSameName.length > 1){
              let isTypesSame = !inputsSameName.find(item => item.getAttribute('type') !== inputsSameName[0].getAttribute('type'))
              let hasRequired = inputsSameName.find(item => typeof item.getAttribute('required') !== 'undefined')
  
              if(!isTypesSame && hasRequired) {
                  if(this.getAttribute('type') === 'checkbox' || this.getAttribute('type') === 'radio'){
                      let diffInputs = inputsSameName.filter(item => item.getAttribute('type') !== this.getAttribute('type'))
                      let thisInputs = inputsSameName.filter(item => item.getAttribute('type') === this.getAttribute('type'))
                      let oneChecked = thisInputs.find(item => item.checked)
  
                      if(diffInputs.length){
                          if(oneChecked){
                              diffInputs.forEach(item => item.removeRequired())
                              diffInputs.forEach(item => item.isValid())
                          } else {
                              diffInputs.forEach(item => item.setRequired())
                          }
                      }
                  }
              }
          }
      }
      let _this = {
          isValid: true,
          allInputs: selectAll(opts.dontValidateInputs, form),
          formSubmitted: false,
          init: function () {
              _this.allInputs = selectAll(opts.dontValidateInputs, form)
              form.setAttribute('novalidate', 'novalidate');
              form.setAttribute('data-js-validation', 'novalidate');
              form.addEventListener('submit', formSubmitListener);
              form.valid = function () {
                  let addErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                  return _this.validate(false, addErrors);
              };
              _this.allInputs.map(function (input) {
                  let thisInputMethods = [];
                  let dataValidation = input.getAttribute('data-validation');
                  if (input.hasAttribute('required')) {
                      thisInputMethods.push({
                          callback: opts.methods['required'],
                          errorMessage: getMethodError(input, 'required', 'This field is required')
                      });
                  }
                  if (input.hasAttribute('data-tel-mask')) {
                      thisInputMethods.push({
                          callback: opts.methods['tel_mask'],
                          errorMessage: ''
                      });
                  }
                  if (input.hasAttribute('minlength')) {
                      thisInputMethods.push({
                          callback: opts.methods['minlength'],
                          errorMessage: getMethodError(input, 'minlength', 'Min length is &1 symbols', [input.getAttribute('minlength')])
                      });
                  }
                  if (input.hasAttribute('maxlength')) {
                      thisInputMethods.push({
                          callback: opts.methods['maxlength'],
                          errorMessage: getMethodError(input, 'maxlength', 'Max length is &1 symbols', [input.getAttribute('maxlength')])
                      });
                  }
  
  
  
  
                  // if (input.getAttribute('type') === 'email') {
                  //   thisInputMethods.push({
                  //     callback: opts.methods['regex'],
                  //     passedValue: email_reg,
                  //     errorMessage: opts.validationErrors['email']['regex'] || opts.validationErrors['invalid'] || 'This field is invalid'
                  //   });
                  // }
                  if (dataValidation) {
                      let thisValidation = opts.validationRules[input.getAttribute('data-validation')];
                      if (thisValidation) {
                          thisValidation = thisValidation['rules'];
                      }
                      if (thisValidation) {
                          Object.keys(thisValidation).forEach(methodName => {
                              let existingMethod = false;
                              let thisValidationValue = thisValidation[methodName];
                              if (opts.methods[methodName]){
                                  existingMethod = {
                                      callback: opts.methods[methodName],
                                      passedValue: thisValidationValue,
                                      errorMessage: getMethodError(input, methodName, opts.validationErrors['invalid'] || 'This field is invalid')
                                  };
                              }
  
                              if (existingMethod) thisInputMethods.push(existingMethod);
                          });
                      }
                  }
                  function isInputRequired() {
                      let removeIt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                      let thisInputActualMethods = input['validationMethods'];
                      let hasRequired = false;
                      thisInputActualMethods.map(function (method) {
                          if (method.callback.name === 'required') {
                              hasRequired = true;
                              if (removeIt) thisInputActualMethods.splice(thisInputActualMethods.indexOf(method), 1);
                          }
                      });
                      return hasRequired;
                  }
                  function setRequired() {
                      let thisInputActualMethods = input['validationMethods'];
                      if (isInputRequired()) return;
                      thisInputActualMethods.push({
                          callback: opts.methods['required'],
                          errorMessage: getMethodError(input, 'required', 'This field is required')
                      });
                      input['validationMethods'] = thisInputMethods;
                  }
                  function removeRequired() {
                      isInputRequired(true);
                  }
                  function setError(message) {
                      _this.highlight(input)
                      _this.errorPlacement(message, input)
                  }
                  function removeError() {
                      _this.unhighlight(input)
                      _this.errorRemove(input)
                  }
                  input['setError'] = setError
                  input['removeError'] = removeError
                  input['setRequired'] = setRequired;
                  input['removeRequired'] = removeRequired;
                  input['isRequired'] = isInputRequired;
                  input['validationMethods'] = thisInputMethods;
                  input['had_input'] = false;
                  input['had_focusout'] = false;
                  input['isValid'] = function () {
                      return _this.valid(input);
                  };
                  input.addEventListener('input', inputInputListener);
                  input.addEventListener('change', inputChangeListener);
                  input.addEventListener('focus', inputFocusListener);
                  input.addEventListener('focusout', inputFocusoutListener);
              });
              if (opts['rules']) {
                  Object.keys(opts['rules']).forEach(function (rule) {
                      let input = document.querySelector('[name="' + rule + '"]');
                      let thisRuleValue = opts['rules'][rule];
                      let thisInputMethods = input['validationMethods'] || [];
                      if (!input) return;
                      if (thisRuleValue['laravelRequired']) thisRuleValue = 'required';
                      let thisRuleMessage = getMethodError(input, thisRuleValue, opts.validationErrors['invalid'] || 'This field is invalid')
                      if (opts['messages'] && opts['messages'][rule] && (opts['messages'][rule][thisRuleValue] || opts['messages'][rule]['laravelRequired'])) thisRuleMessage = opts['messages'][rule][thisRuleValue] || opts['messages'][rule]['laravelRequired'];
                      if (opts.methods[thisRuleValue]) {
                          thisInputMethods.push({
                              callback: opts.methods[thisRuleValue],
                              errorMessage: thisRuleMessage
                          });
                          input['validationMethods'] = thisInputMethods;
                      }
                  });
              }
          },
          destroy: function () {
              form.removeAttribute('novalidate', 'novalidate');
              form.removeAttribute('data-js-validation', 'novalidate');
              form.removeEventListener('submit', formSubmitListener);
              form.valid = null;
              _this.allInputs.map(function (input) {
                  input['setError'] = null
                  input['removeError'] = null
                  input['setRequired'] = null;
                  input['removeRequired'] = null;
                  input['isRequired'] = null;
                  input['validationMethods'] = null;
                  input['had_input'] = false;
                  input['had_focusout'] = false;
                  input['isValid'] = null
                  input.removeEventListener('input', inputInputListener);
                  input.removeEventListener('change', inputChangeListener);
                  input.removeEventListener('focus', inputFocusListener);
                  input.removeEventListener('focusout', inputFocusoutListener);
              });
          },
          valid: function (input) {
              if(input['dont-check']){
                  return true;
              }
              let checkMethods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
              let addError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              let thisMethods = input['validationMethods'];
              if (!thisMethods) return true;
              let isInputValid = true;
              if (checkMethods.length) {
                  thisMethods = [];
                  checkMethods.forEach(function (thisMethod) {
                      let thisInputMethod = input['validationMethods'].find(obj => obj.callback.name === thisMethod);
                      if (thisInputMethod) {
                          thisMethods.push(thisInputMethod);
                      }
                  });
              }
              thisMethods.forEach(function (thisMethod) {
                  if (!isInputValid) return;
                  let isThisValid = thisMethod['callback'](input.value, input, thisMethod['passedValue']);
                  if (!isThisValid) {
                      if (addError) {
                          _this.errorPlacement(thisMethod['errorMessage'], input);
                          _this.highlight(input);
                      }
                      _this.isValid = isInputValid = input['validity']['valid'] = false;
                  }
              });
              if (isInputValid) {
                  _this.errorRemove(input);
                  _this.unhighlight(input);
                  input['validity']['valid'] = true;
              }
              return isInputValid;
          },
          validate: function () {
              let submit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
              let addError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              _this.isValid = true;
              _this.allInputs.map(function (input) {
                  if (!_this.valid(input, addError)) {
                      _this.isValid = false;
                  }
              });
              if (_this.isValid && submit) _this.submitHandler();
              return _this.isValid;
          },
          highlight: function (element) {
              if (typeof opts.highlightFunction === 'function') {
                  opts.highlightFunction(form, element);
                  return;
              }
              let container;
              if(typeof opts.inputContainerSelector === 'object'){
                  opts.inputContainerSelector.forEach(function (item) {
                      if(element.closest(item)) {
                          container = element.closest(item)
                      }
                  })
              } else {
                  container = element.closest(opts.inputContainerSelector)
              }
              if (container) container.classList.add(opts.errorClass);
          },
          unhighlight: function (element) {
              if (typeof opts.unhighlightFunction === 'function') {
                  opts.unhighlightFunction(form, element);
                  return;
              }
              let container;
              if(typeof opts.inputContainerSelector === 'object'){
                  opts.inputContainerSelector.forEach(function (item) {
                      if(element.closest(item)) {
                          container = element.closest(item)
                      }
                  })
              } else {
                  container = element.closest(opts.inputContainerSelector)
              }
              if (container) container.classList.remove(opts.errorClass);
          },
          errorPlacement: function (error, element) {
              if (!error) return;
              let container;
              if(typeof opts.inputContainerSelector === 'object'){
                  opts.inputContainerSelector.forEach(function (item) {
                      if(element.closest(item)) {
                          container = element.closest(item)
                      }
                  })
              } else {
                  container = element.closest(opts.inputContainerSelector)
              }
              if (!container){ console.warn('BLACKBOOK Validate: no container for: ', element, opts.inputContainerSelector); return; }
              let errorEl = container.querySelector('.input__error');
              if (!errorEl) {
                  errorEl = document.createElement('div');
                  errorEl.classList.add('input__error');
                  container.append(errorEl);
              }
              errorEl.innerHTML = `<p>${error}</p>`;
          },
          errorRemove: function (element) {
              let container;
              if(typeof opts.inputContainerSelector === 'object'){
                  opts.inputContainerSelector.forEach(function (item) {
                      if(element.closest(item)) {
                          container = element.closest(item)
                      }
                  })
              } else {
                  container = element.closest(opts.inputContainerSelector)
              }
              if (!container){ console.warn('BLACKBOOK Validate: no container for: ', element, opts.inputContainerSelector);  return;  }
              container = container.querySelector('.input__error');
              if (!container) return;
              container.innerHTML = '';
          },
          submitHandler: function () {
              if (typeof opts.submitFunction === 'function') {
                  opts.submitFunction(form);
              } else {
                  form.submit();
              }
          }
      };
  
      if (form.hasAttribute('data-js-validation')){
          _this.destroy();
          _this.init();
      } else {
          _this.init();
      }
      form.validateMethods = _this;
      return _this;
  }
    function beforeForm(form) {
      form.querySelector('[type="submit"]').setAttribute('disabled', 'disabled');
      form.classList.remove('ajax-error');
    }
    function resetForm(form) {
      let successContainer = $(form).closest('.show-hide-container');
      let successBlockShow = successContainer.find('.show-on-success');
      let successBlockHide = successContainer.find('.hide-on-success');
      if (successContainer.length && successBlockShow.length) {
        if (successBlockHide.length) {
          successBlockHide.fadeOut(300, function () {
            successBlockShow.fadeIn(300);
          });
        } else {
          successBlockShow.fadeIn(300);
        }
        if (!$('.fancybox__container').length) $("html, body").animate({
          scrollTop: 0
        }, "slow");
      }
      form.reset();
      form.querySelectorAll('.is-selected').forEach(function(item){
        item.classList.remove('is-selected')
      });

      form.querySelector('[type="submit"]').removeAttribute('disabled');
      selectAll('.input--file').map(function (input) {
        input.querySelector('[data-placeholder]').innerHTML = input.querySelector('[data-placeholder]').getAttribute('data-placeholder');
      });
    }
    function ajaxError(form, data) {
      form.querySelector('[type="submit"]').removeAttribute('disabled');
      if (data['responseJSON'] && data['responseJSON']['data'] && typeof data['responseJSON']['data'] === 'string') {
        $(form).find('.form__error').text(data['responseJSON']['data']);
        $(form).addClass('ajax-error');
      }
    }
    function initSwiper(slider, slidesVisible, swiperParams) {
      let check = setInterval(function (){
          let slides = slider.querySelectorAll('.swiper-slide')

          if(slides.length >= slidesVisible){
            clearInterval(check)
            return;
          }

          slides.forEach(function (slide) {
              slider.querySelector('.swiper-wrapper').innerHTML += slide.outerHTML
          })
      }, 1)
      setTimeout(function(){
        new Swiper(slider, swiperParams)
      },300)
    }
    if(typeof closestEl === 'undefined') {
      function closestEl(el, closestParent){
        let foundClosest = false;
        let nextParent = el;
        let i = 0
    
        while (true){
          i++;
          if(!nextParent || nextParent.nodeName === 'BODY' || i > 20){
              break;
          }
          if(nextParent == closestParent){
              foundClosest = nextParent
              break;
          }
          nextParent = nextParent.parentElement
        }
    
        return foundClosest;
      }
    }
    if(typeof dynamicListener === 'undefined') {
      function dynamicListener(event, selector, handler){
        document.addEventListener(event, function (e) {
          let selectorEls = document.querySelectorAll(selector)
  
          selectorEls.forEach(function (selectorEl) {
            if(e.target === selectorEl || closestEl(e.target, selectorEl)){
              handler(e)
            }
          })
        })
      }
    }
    function trigger(el, eventName, params = {}) {
      let thisEl = el
      let thisEventName = eventName
      let thisParams = params
  
      if(typeof el === 'string'){
          thisEventName = el
          thisEl = document
          if(typeof eventName === 'object'){
              thisParams = eventName
          }
      }
  
      let newEvent = new CustomEvent(thisEventName, { bubbles: true, detail: thisParams });
      thisEl.dispatchEvent(newEvent)
    }
    function blocks() {
      let methods = {
        '.header': function (sections) {
          sections.forEach(function (section) {
            let burger = section.querySelector(".burger");
            let menu = document.querySelector(".menu");
            let body = document.querySelector(".page__body");
            let menuClose = document.querySelector(".menu__close");
            burger.addEventListener('click', function () {
              menu.classList.add('is-active');
              body.classList.add('menu-open');
            });
            menuClose.addEventListener('click', function () {
              menu.classList.remove('is-active');
              body.classList.remove('menu-open');
            });
          });
        },
        '.scroll-top':function(btns){
          let promo = document.querySelector('section');          
          let heightPromo = promo.offsetHeight;
                  
          window.addEventListener('scroll', function() {
            let scrollPosition = window.scrollY;
        
            if (scrollPosition >= heightPromo) {
              btns.forEach(function(btn) {
                btn.classList.add('active') 
              });
            } else {
              btns.forEach(function(btn) {
                btn.classList.remove('active') 
              });
            }
          });

          btns.forEach(function(btn) {
            btn.addEventListener('click', function() {
              $('html,body').animate({
                scrollTop: 0
              }, {
                duration: 1000,
                complete: function() {
                  window.addEventListener('scroll', scrollHandler);
                }
              });
              window.removeEventListener('scroll', scrollHandler);
            });
          });
        
          function scrollHandler() {
          }
        
          window.addEventListener('scroll', scrollHandler);
        },
        '.card-slider':function(sections){
          sections.forEach(function(section){
            let cardSlider = section.querySelector('.swiper');
            let btnPrev = section.querySelector('.section-slider__prev'); 
            let btnNext = section.querySelector('.section-slider__next');
            new Swiper(cardSlider, {
              spaceBetween: 20,
              slidesPerView: 'auto',
              speed: 690,
              // autoplay: {
              //   delay: 3000
              // },
              navigation: {
                nextEl: btnNext,
                prevEl: btnPrev,
              },
              breakpoints: {
                // when window width is >= 320px
                768: {
                  slidesPerView: 5,
                  autoHeight: false,
                }
              }
            });
          })
        },
        '.triple-swiper': function (sections) {
          sections.forEach(function (section) {
            let btnPrev = section.querySelector('.section-slider__prev'); 
            let btnNext = section.querySelector('.section-slider__next');
            let instance = new Swiper(section, {
              init: false,
              effect: "carousel",
              grabCursor: true,
              loop: true,
              speed: 600,
              slidesPerView: "auto",
              navigation: {
                nextEl: btnNext,
                prevEl: btnPrev,
              },
            });
    
            instance.on('beforeInit', function() {
              if (instance.params.effect !== "carousel") return;
    
              instance.classNames.push(`${instance.params.containerModifierClass}carousel`);
    
              const carouselParams = {
                watchSlidesProgress: true,
                centeredSlides: true
              };
    
              Object.assign(instance.params, carouselParams);
              Object.assign(instance.originalParams, carouselParams);
            });
    
            instance.on('progress', function() {
              if (instance.params.effect !== "carousel") return;
    
              const totalSlides = instance.slides.length;
    
              for (let i = 0; i < instance.slides.length; i += 1) {
                const slide = instance.slides[i];
                let progress = slide.progress;
                if (progress > 1) {
                  progress = 1
                }
                
                if (progress < -1) {
                  progress = -1
                }
                const absProgress = Math.abs(progress);
                let scale = 1;
                let slideWidth = slide.offsetWidth
                let offsetTransform = (slideWidth * (1 - (1 * 0.53)) / 2)  * (1-progress * -1)
                
                if (absProgress > 0) {
                  scale = 1 - (absProgress * 0.3)
                }
                
                
                const mobOffset = 13
                let prev = 0
                let translateX = progress * scale * 10
                const translateY = absProgress * scale * -21 * -1 + "%";
                const zIndex = totalSlides - Math.abs(Math.round(progress));
                const opacity = absProgress > 2 ? 0 : 1;
    
                slide.style.zIndex = zIndex;
                slide.style.opacity = opacity;


                if(Number.isInteger){
                  setTimeout(function () {
                    slide.style.transform = `translate(${translateX}%, 0px) scale(${scale})`;
                  },10)
                } else {
                  slide.style.transform = `translate(${translateX}%, 0px) scale(${scale})`;
                }
  
              }
            });
    
            instance.on('setTransition', function(duration, speed) {
              if (instance.params.effect === "carousel") {
                for (let i = 0; i < instance.slides.length; i += 1) {
                  const slide = instance.slides[i];
    
                  slide.style.transitionDuration = `${speed}ms`;
                }
              }
            });
    
            instance.init();
    
          });
        },
        '.career':function(sections){
          sections.forEach(function(section){
            let careerSlider = section.querySelector('.swiper');
            new Swiper(careerSlider, {
              spaceBetween: 30,
              slidesPerView: 1,
              speed: 690,
              autoHeight: true,
              pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
              },
            });
          })
          $(document).on('click', '.career .swiper-pagination-bullet', function(){
            $('html,body').animate({
              scrollTop: $(this).closest('.swiper').offset().top
            }, {
              duration: 600
            });
          })
        },
        '.section-text-wrap': function (sections) {
          sections.forEach(function (section) {
            let textShow = section.querySelector('.section-text-hide');
            let button = section.querySelector('.section-link');
            if (!button) return
            button.addEventListener('click', function () {
              let buttonText = this.querySelector('span');
              slideToggle(textShow, 300);
              this.classList.toggle('is-show');
              if (this.classList.contains('is-show')) {
                buttonText.textContent = this.dataset.closeText;
              } else {
                buttonText.textContent = this.dataset.openText;
              }
            });
          });
        },
        '.section-text-wrapper': function (sections) {
          sections.forEach(function (section) {
            let textShow = section.querySelector('.section-text-hide');
            let buttonOpen = section.querySelector('.section-link__open');
            let buttonClose = section.querySelector('.section-link__close');
            if (!buttonOpen) return
            if (!buttonClose) return

            buttonOpen.addEventListener('click', function(){
              slideDown(textShow, 300);
              fadeOut(this, 300)
              fadeIn(buttonClose, 300, 'flex')
            })

            buttonClose.addEventListener('click', function(){
              slideUp(textShow, 300);
              fadeOut(this, 300)
              fadeIn(buttonOpen,300, 'flex')
            })
          });
        },
        '[data-tab-btn]': function (btns) {
          btns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                if (!this.classList.contains('active')) {
                  btns.forEach(function (item) {
                    item.classList.remove('active');
                  });
                }
                this.classList.add('active');
                let thisTab = document.querySelector(' [data-tab="' + this.getAttribute('data-tab-btn') + '"]');
                let elseTab = document.querySelector(' .active[data-tab]');
                if (!elseTab) {
                  thisTab.classList.add('active');
                  return;
                }
                thisTab.classList.add('active');
                elseTab.classList.remove('active');
                fadeOut(elseTab, 500, function () {
                  fadeIn(thisTab, 500);
                });
              });
            });
            document.querySelectorAll('button[data-tab-btn]:first-child').forEach(function(btn){
              btn.click()
            });
        },
        '.input--select': function(inputs){
          dropdown({
              containerClass: 'input--select',
              btnSelector: '.output_text',
              closeBtnClass: '',
              dropdownSelector: 'ul',
              effect: 'fade',
              timing: 200,
          });

          inputs.forEach(function(input){
            let checkboxes = input.querySelectorAll('input[name="services[]"]');
            let outputText = input.querySelector('.output_text');
            
            checkboxes.forEach(function (checkbox) {
              checkbox.addEventListener('change', function () {
                let selectedServices = [];
  
                checkboxes.forEach(function (checkbox) {
                  if (checkbox.checked) {
                    selectedServices.push(checkbox.value);
                  }
                });
                outputText.value = selectedServices.join(', ');
              });
            });
          })
          

          function selectMobVariation (e) {
              let option = $(this);
              if (! e['originalEvent']) option = e;
              if (option.hasClass ('input__search') || option.find ('a').length) return;
              let container = option.closest ('.input--select');
              let text = container.hasClass ('output-html')? option.html ().trim (): option.text ().trim ();
              let value = option.attr ('data-value');
              let outText = container.find ('.output_text');
              let outValue = container.find ('.output_value');
      
              if (! container.hasClass ('no-output')) {
                  if (outText.length && text) {
                      if (outText.is ('input')) {
                          outText.val (text);
                      } else {
                          outText.html (text);
                      }
                  }
              }
              if (outValue.length) {
                  outValue.val(value);
                  outValue.trigger('change')
                  trigger(outValue[0], 'change')
                  if (typeof outValue[0].isValid === 'function'){
                    outValue[0].isValid ();
                  }
              }
              option.addClass('is-selected');
              option.siblings().removeClass ('is-selected');
              if(!container.hasClass('has-checkbox')) 
                $(document).trigger('close-dropdown')
          }
          $(document).on('click', '.input--select li', selectMobVariation);
          $('.input--select .is-selected').each(function () {
            selectMobVariation($(this));
          });
        },
        '.form': function(forms){
            function onSubmit(form){
              let formData = new FormData(form);
              let formFeedback = form.querySelector('.form__feedback');
              let action = form.getAttribute('action') || '';    
              let method = form.getAttribute('method') || 'post';
              let formBtn = form.querySelector('[type="submit"]')
              
              formBtn.setAttribute('disabled', 'disabled');
    
                $.ajax({
                  url: action,
                  method: method,
                  enctype: 'multipart/form-data',
                  processData: false,
                  contentType: false,
                  cache: false,
                  data: formData,
                  headers: {
                      "X-Requested_With": "XMLHttpRequest",
                      "X-CSRFToken": typeof csrftoken !== 'undefined' ? csrftoken : '',
                  },
                    error: function(data){
                      formBtn.removeAttribute('disabled');
                      resetForm(form);
                      if($('#consultants_block').length){
                        let responseEl = $(data)

                        responseEl.find('.teams-card').addClass('scroll-appearance-shown');
                        $('#consultants_block').html(responseEl.find('#consultants_block').html())
                      }
                      if(form.dataset.successPopup){
                         Fancybox.show([{
                          src: form.dataset.successPopup,
                          type: 'inline',
                          placeFocusBack: false,
                          trapFocus: false,
                          autoFocus: false,
                        }], {
                          dragToClose: false,
                      });
                      }
                      if(formFeedback){
                        if(data.error){
                          // delete previous result block
                          var successBlock = formFeedback.getElementsByClassName('ajax_success')[0];
                          if (successBlock) {
                              successBlock.remove();
                          }
                          var errorBlock = formFeedback.getElementsByClassName('ajax_error')[0];
                          if (errorBlock) {
                              errorBlock.remove();
                          }
      
                          // error block
                          var errors = document.createElement("div");
                          errors.className = "ajax_error";
                          // errors.textContent = result.error;
                          errors.innerHTML = result.error_description;
                          formFeedback.append(errors);
                        }else{
                          // delete previous result block
                          var successBlock = formFeedback.getElementsByClassName('ajax_success')[0];
                          if (successBlock) {
                              successBlock.remove();
                          }
                          var errorBlock = formFeedback.getElementsByClassName('ajax_error')[0];
                          if (errorBlock) {
                              errorBlock.remove();
                          }
      
                          // success block
                          var success = document.createElement("div");
                          success.className = "ajax_success";
                          success.textContent = "Thank you for your submission. One of our staff members will contact You.";
                          formFeedback.append(success);
                        }
                      }
                    },
                    errorr: function(error){
                      if(formFeedback){
                        // delete previous result block
                        var successBlock = formFeedback.getElementsByClassName('ajax_success')[0];
                        if (successBlock) {
                            successBlock.remove();
                        }
                        var errorBlock = formFeedback.getElementsByClassName('ajax_error')[0];
                        if (errorBlock) {
                            errorBlock.remove();
                        }
    
                        // error block
                        var error = document.createElement("div");
                        error.className = "ajax_error";
                        error.innerText = '500 (Internal Server Error)';
                        formBtn.removeAttribute('disabled');
                        formFeedback.append(error);
                      }
                    }
                });
            }
    
            forms.forEach(function(form) {
              validate(form, {submitFunction: onSubmit})
            })
        },
        '.menu': function (menus) {
          menus.forEach(function (menu) {
            let accordions = menu.querySelectorAll('.has-child');
            accordions.forEach(function (accordion) {
              accordion.addEventListener('click', function (e) {
                // e.preventDefault();
                e.stopPropagation();
                const self = this.closest('.has-child');
                const content = self.querySelector('ul');
                setTimeout(function(){
                  slideToggle(content, 300);
                  self.classList.toggle('is-open');
                },100)
              });
            });
          });
        },
        '.scroll-appearance-section': function (sections) {
          $(sections).each(function () {
            $(this).scrollAppearance(200, 0)
          })
        },
        '.slider-images': function (sections) {
          sections.forEach(function (section) {  
            let btnPrev = section.querySelector('.section-slider__prev'); 
            let btnNext = section.querySelector('.section-slider__next');
            let slider = section.querySelector('.swiper')
            // let slides = section.querySelectorAll('.swiper-slide')
            
            initSwiper(slider, 5,  {
              effect: "creative",
              allowTouchMove: true,
              creativeEffect: {
                prev: {
                  translate: ["-105%", 0, -1],
                },
                active: {
                  translate: [0, 0, 1],
                },
                next: {
                  translate: ["105%", 0, 0],
                }
              },
              grabCursor: true,
              speed: 700,
              slidesPerView: 1,
              loop: true,
              spaceBetween: 20,
              navigation: {
                nextEl: btnNext,
                prevEl: btnPrev,
              },
              pagination: {
                el: ".swiper-pagination",
              },
              breakpoints: {
                // when window width is >= 320px
                769: {
                  slidesPerView: "auto",
                  spaceBetween: 0,
                  creativeEffect: {
                    limitProgress: 4,
                    prev: {
                      translate: ["-2rem", "-3.5rem", -1],
                    },
                    active: {
                      translate: [0, 0, 1],
                    },
                    next: {
                      translate: ["2rem", "3.5rem", 0],
                    }
                  },
                },
              }
            })
            
          });
        },
        '.teams': function(sections){
          let form = document.querySelector('.teams__form');
          let formBtn = form.querySelector('[type="submit"]');

          function checkInputs(e){
            let thisInput = e.target
            let blocks = document.querySelectorAll('.teams__input')
            let thisBlock = thisInput.closest('.teams__input')
            let isFilled = false;

            blocks = Array.from(blocks).filter(item => item != thisBlock)

            if(thisInput.getAttribute('type') == 'checkbox'){
              thisBlock.querySelectorAll('input[type="checkbox"]').forEach(function(checkboxInput){
                if(checkboxInput.checked){
                  isFilled = true;
                }
              })
            } else{
              if(thisInput.value){
                isFilled = true;
              }
            }
            
            
            checkForm(blocks, isFilled)
          }
          function checkForm(blocks, isFilled = false){
            if(!blocks || !blocks.length){
              blocks = document.querySelectorAll('.teams__input')
            }
            blocks.forEach(function(block){
              let blockCheckboxes = block.querySelectorAll('input[type="checkbox"]')
              let blockOutput = block.querySelector('input.output_value')
              let blockInput = block.querySelector('input:not([type="checkbox"]):not(.output_text):not(.output_value)')

              if(isFilled){
                block.classList.add('is-disabled')

                if(blockCheckboxes.length){
                  blockCheckboxes.forEach(function(checkboxInput){
                    checkboxInput.removeRequired()
                    checkboxInput.removeError()
                  })
                }
                if(blockOutput){
                  blockOutput.removeRequired()
                  blockOutput.removeError()
                }
                if(blockInput){
                  blockInput.removeRequired()
                  blockInput.removeError()
                }

                formBtn.removeAttribute('disabled')
              } else {
                block.classList.remove('is-disabled')

                if(blockCheckboxes.length){
                  blockCheckboxes.forEach(function(checkboxInput){
                    checkboxInput.setRequired()
                    checkboxInput.removeError()
                  })
                }
                if(blockOutput){
                  blockOutput.setRequired()
                  blockOutput.removeError()
                }
                if(blockInput){
                  blockInput.setRequired()
                  blockInput.removeError()
                }
                
                formBtn.setAttribute('disabled', 'disabled')
              }
            })
          }
          
          resetForm(form);
          checkForm()

          formBtn.setAttribute('disabled', 'disabled')
          
          form.addEventListener('submit', function(){
            setTimeout(() => {
              checkForm()
              
            }, 500);
          })
          form.querySelectorAll('.teams__input input').forEach(function(input){
            input.addEventListener('change', checkInputs)
            input.addEventListener('input', checkInputs)
          });
        }
      };
      Object.keys(methods).forEach(selector => {
        if (document.querySelector(selector)) methods[selector](document.querySelectorAll(selector));
      });
    }
    document.addEventListener('DOMContentLoaded', function () {
      blocks();
      anchors();

    
      Fancybox.bind('[data-fancybox]', {
        dragToClose: false,
      })
      
    });


    // Fancybox.show([{
    //     src: '#modal_error',
    //     type: 'inline',
    //     placeFocusBack: false,
    //     trapFocus: false,
    //     autoFocus: false,
    //   }], {
    //     dragToClose: false,
    //     on: {
    //       "destroy": (event, fancybox, slide) => {
    //         clearTimeout(closeTimeout)
    
    //         if(activePopup){
    //           openPopup(false, activePopup)
    //         }
    //       },
    //     }
    // });
    /******/ })()
    ;
    //# sourceMappingURL=main.js.map